import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

// Modal séparé
import SessionModal from "./partials/SessionModal";

//import ImportCourseUnitModal from "./partials/ImportCourseUnitModal";

import {
    getSessions as onGetSessions,
    addNewSession as onAddNewSession,
    updateSession as onUpdateSession,
    deleteSession as onDeleteSession,

    getSessionTypes as onGetSessionTypes,
    //getTeachers as onGetTeachers,
    //getSemesters as onGetSemesters,

    resetSessionLastActionSuccess as OnResetSessionLastActionSuccess

} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";

import Select from "react-select";

import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Session = () => {

    //meta title
    document.title = "Sessions | CinzanEdu";

    const dispatch = useDispatch();
    
    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [session, setSession] = useState(null);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadingState, setLoadingState] = useState(true);

    const [modalOpen, setModalOpen] = useState(false);


    const navigate = useNavigate();

    


 

    // Selector Sessions
    const SessionProperties = createSelector(
        (state) => state.sessionReducer, 
        (sessionReducer) => ({
            sessions: sessionReducer.sessions,
            loading: sessionReducer.loading,
            lastActionSuccess: sessionReducer.success
        })
    );

    const {sessions, loading, lastActionSuccess} = useSelector(SessionProperties);
    const [isLoading, setLoading] = useState(loading);




    // Selector session types
    const SessionTypeProperties = createSelector(
        (state) => state.sessionTypeReducer, 
        (sessionTypeReducer) => ({
            sessionTypes: sessionTypeReducer.sessionTypes,
            loading: sessionTypeReducer.loading
        })
    );   
    const {sessionTypes} = useSelector(SessionTypeProperties);

 


    // Chargement initial des données
    useEffect(() => {
        if (!sessions.length) dispatch(onGetSessions());
        if (!sessionTypes.length) dispatch(onGetSessionTypes());
     
        setLoadingState(loading);
    }, [dispatch, sessions.length, sessionTypes.length,  loading]);
    






    // Ferme le modal en cas de success
    useEffect(() => {
        
    if (lastActionSuccess && modal) {
        toggle();
        setSession(null);
        dispatch(OnResetSessionLastActionSuccess()); // action qui remet à false
    }
    }, [lastActionSuccess, modal, dispatch]);
    
    
    // Toggle modal
    const toggle = () => {
        setModal(!modal);
        if (modal) setSession(null);
    };
    
    // Créer nouvelle course unit
    const onClickNewSession = () => {
        setIsEdit(false);
        setSession(null);
        toggle();
    };
    
    // Edit course unit
    const handleSessionClick = (session) => {
        setSession(session);
        setIsEdit(true);
        toggle();
        dispatch(OnResetSessionLastActionSuccess()); // reset pour l’édition
    };
        
    // Delete course unit
    const onClickDelete = (session) => {
        setSession(session);
        setDeleteModal(true);
    };
    const handleDeleteSession = () => {
        if (session?.id) {
        dispatch(onDeleteSession(session));
        setDeleteModal(false);
        }
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };



    

    
        

    

  

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Titre",
                accessorKey: "title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Type",
                accessorKey: "session_type.title",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Date début",
                accessorKey: "start_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Date fin",
                accessorKey: "end_date",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Statut",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    const status = cellProps.row.original.status;
                    if (status === "OPEN") {
                        return <Badge className="bg-success">Ouverte</Badge>;
                    } else if (status === "CLOSED") {
                        return <Badge className="bg-danger">Fermée</Badge>;
                    }
                    return <Badge className="bg-secondary">{status}</Badge>;
                }
            },
               {
                header: "Actions",
                accessorKey: "actions",
                enableColumnFilter: false,
                enableSorting: false,
                // On définit une largeur suffisante pour contenir les trois boutons texte+icône
                cell: (cellProps) => {
                    const session = cellProps.row.original;
                    return (
                        <div className="d-flex gap-2 justify-content-centerr">
                            {/* BOUTON MODIFIER */}
                            <button
                                type="button"
                                className="btn btn-soft-success btn-sm d-flex align-items-center"
                                onClick={() => handleSessionClick(session)}
                            >
                                <i className="mdi mdi-pencil font-size-14 me-1"></i>
                                Modifier
                            </button>

                           

                            {/* BOUTON SUPPRIMER */}
                            <button
                                type="button"
                                className="btn btn-soft-danger btn-sm d-flex align-items-center"
                                onClick={() => onClickDelete(session)}
                            >
                                <i className="mdi mdi-trash-can font-size-14 me-1"></i>
                                Supprimer
                            </button>

                             {/* BOUTON EXAMENS (Le pivot du workflow) */}
                            <button
                                type="button"
                                className="btn btn-soft-primary btn-sm d-flex align-items-center"
                                onClick={() => navigate(`/session/${session.uuid}/exams`)}
                            >
                                <i className="bx bx-list-ul font-size-14 me-1"></i>
                                Examens
                            </button>
                        </div>
                    );
                }
            }
            
            
            
            
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteSession}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Sessions" breadcrumbItem="Liste des sessions" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                  

                                                    <Link to="#!" onClick={onClickNewSession} className="btn btn-primary me-1">Ajouter une session</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={sessions || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }

                    {/* Modal de Session avec rendu conditionnel */}
                    {modal && (
                        <SessionModal
                            modal={modal}
                            toggle={toggle}
                            isEdit={isEdit}
                            session={session}
                            sessionTypes={sessionTypes}
                            onSubmit={(payload) => {
                                if (isEdit) {
                                    dispatch(onUpdateSession(payload));
                                } else {
                                    dispatch(onAddNewSession(payload));
                                }
                            }}
                        />
                    )}


                </div>
            </div>
            <ToastContainer />

            
        </React.Fragment>
    );
}


export default Session;